let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("hoh19")]).then(() => parcelRequire('17J6g'));